/**
 * DUEL Coach Storage — AsyncStorage-based persistence for coach profile and plan.
 * No Supabase, no migrations, no DB changes.
 *
 * Doctrine: AGENTS.md — DUEL workspace only.
 */

import AsyncStorage from '@react-native-async-storage/async-storage';
import type { CoachProfile, CoachWeekPlan } from '@/lib/coachEngine';

const profileKey = (userId: string) => `duel_coach_profile_${userId}`;
const planKey = (userId: string) => `duel_coach_plan_${userId}`;

export async function saveCoachProfile(userId: string, profile: CoachProfile): Promise<void> {
  await AsyncStorage.setItem(profileKey(userId), JSON.stringify(profile));
}

export async function loadCoachProfile(userId: string): Promise<CoachProfile | null> {
  try {
    const raw = await AsyncStorage.getItem(profileKey(userId));
    if (!raw) return null;
    return JSON.parse(raw) as CoachProfile;
  } catch {
    return null;
  }
}

export async function saveCoachPlan(userId: string, plan: CoachWeekPlan): Promise<void> {
  await AsyncStorage.setItem(planKey(userId), JSON.stringify(plan));
}

export async function loadCoachPlan(userId: string): Promise<CoachWeekPlan | null> {
  try {
    const raw = await AsyncStorage.getItem(planKey(userId));
    if (!raw) return null;
    return JSON.parse(raw) as CoachWeekPlan;
  } catch {
    return null;
  }
}

export async function clearCoachData(userId: string): Promise<void> {
  await AsyncStorage.multiRemove([profileKey(userId), planKey(userId)]);
}
